import { useStoreState } from '@seller-hermes/hooks/easy-peasy';
import {
  getSellerGroupFeatureFlag,
  useSellerGroupFeatureFlag,
} from '@seller-hermes/hooks/useSellerGroupFeatureFlag';
import { UserTypeEnum } from '@seller-hermes/features/users/users.types';
import type { SellerGroupUser } from '@seller-hermes/features/seller-group';

/**
 * Grupo legado = `feature_config.legacy_automation` é o booleano `true`.
 * Ausente, null, false ou qualquer outro valor (ex.: string "true") contam
 * como grupo COM Workflows.
 */
export const isLegacyAutomation = (user?: SellerGroupUser | null): boolean =>
  getSellerGroupFeatureFlag('legacy_automation', user) === true;

export const useIsLegacyAutomation = (): boolean =>
  useSellerGroupFeatureFlag('legacy_automation') === true;

/**
 * Workflow editor está acessível para usuários MASTER ou INTERNAL **e** cujo
 * seller group não tem `legacy_automation`. Sem bypass de INTERNAL. Espelha o
 * `RequireAnyOfTheseUserTypes(INTERNAL, MASTER)` do BFF.
 */
export const canAccessWorkflows = (user?: SellerGroupUser | null): boolean => {
  if (!user) return false;
  const typeOk =
    user.type === UserTypeEnum.MASTER || user.type === UserTypeEnum.INTERNAL;
  return typeOk && !isLegacyAutomation(user);
};

export const useCanAccessWorkflows = (): boolean => {
  const user = useStoreState((s) => s.login.sellerGroupUser?.user);
  return canAccessWorkflows(user);
};

export default useCanAccessWorkflows;
